(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5335],{

/***/ 49798:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-businesses",
      function () {
        return __webpack_require__(64642);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = noSSR;
exports["default"] = dynamic;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _loadable = _interopRequireDefault(__webpack_require__(14302));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isServerSide = "object" === 'undefined';
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        /*#__PURE__*/ return _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === 'function') {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === 'object') {
        loadableOptions = _objectSpread({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _objectSpread({}, loadableOptions, options);
    var suspenseOptions = loadableOptions;
    if (true) {
        // Error if react root is not enabled and `suspense` option is set to true
        if ( true && suspenseOptions.suspense) {
            // TODO: add error doc when this feature is stable
            throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
        }
    }
    if (suspenseOptions.suspense) {
        return loadableFn(suspenseOptions);
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _objectSpread({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false})
    if (typeof loadableOptions.ssr === 'boolean') {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _useSubscription = __webpack_require__(67161);
var _loadableContext = __webpack_require__(16319);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        var state = (0, _useSubscription).useSubscription(subscription);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        return _react.default.createElement(opts.lazy, _objectSpread({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== 'undefined' && !opts.suspense) {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return !opts.suspense && init();
    };
    LoadableComponent.displayName = 'LoadableComponent';
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === 'number') {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            var _this1 = this;
                            this._delay = setTimeout(function() {
                                _this1._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === 'number') {
                        var _this2 = this;
                        this._timeout = setTimeout(function() {
                            _this2._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _objectSpread({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 56794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Authors; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function Authors(param1) {
    var people = param1.people, _expand = param1.expand, expand = _expand === void 0 ? true : _expand, _showTitle = param1.showTitle, showTitle = _showTitle === void 0 ? false : _showTitle;
    return people.map(function(param, index) {
        var name = param.name, image = param.photo, title = param.title;
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('relative z-10 inline-flex items-center', {
                'mx-3': expand,
                'ml-[-16px]': !expand
            }),
            children: [
                image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('inline-flex rounded-full border-2 border-white bg-gray-200', {
                        'mr-3': expand
                    }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        src: image.url,
                        title: name,
                        alt: name,
                        width: 36,
                        height: 36,
                        objectFit: "cover",
                        className: "flex rounded-full"
                    })
                }),
                expand && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-sm md:text-base",
                    children: [
                        name,
                        showTitle && title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "block text-xs font-bold uppercase text-cornflower",
                            children: title
                        })
                    ]
                })
            ]
        }, index);
    });
};


/***/ }),

/***/ 83228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function CardLink(param) {
    var children = param.children, className = param.className, externalUrl = param.externalUrl, linkPath = param.linkPath;
    var linkClassName = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'flex flex-1 flex-col group');
    if (externalUrl) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: externalUrl,
            target: "_blank",
            rel: "nofollow noopener noreferrer",
            className: linkClassName,
            children: children
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
        href: linkPath,
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: linkClassName,
            children: children
        })
    }));
};


/***/ }),

/***/ 63016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ DefaultLogoReel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _svg_logos_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68953);



function DefaultLogoReel(param) {
    var _showPretext = param.showPretext, showPretext = _showPretext === void 0 ? true : _showPretext, pretext = param.pretext, className = param.className;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("mx-auto max-w-full px-6 text-center", className),
        children: [
            showPretext && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mb-8 text-lg font-semibold text-haiti",
                children: pretext || "Trusted by teams of all sizes to deliver content to millions across the world"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg_logos_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: "mx-auto block max-w-full"
            })
        ]
    }));
}


/***/ }),

/***/ 79506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Pill; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function Pill(param) {
    var className = param.className, _colour = param.colour, colour = _colour === void 0 ? 'pink' : _colour, label = param.label, _size = param.size, size = _size === void 0 ? 'regular' : _size;
    var colourClass = function(colourParam) {
        switch(colourParam.toUpperCase()){
            case 'BLACK':
                return 'bg-haiti text-white';
            case 'DARK_BLUE':
                return 'bg-zodiac text-white';
            case 'PINK':
                return 'bg-lavender-blush text-rose';
            default:
                return 'bg-rose text-white';
            case 'PURPLE':
                return 'bg-faded-cornflower text-cornflower';
        }
    };
    var sizeClass = function(sizeParam) {
        switch(sizeParam){
            case 'small':
                return 'px-1 rounded-sm text-xxs';
            case 'large':
                return 'md:text-base px-2 py-1 rounded text-sm';
            case 'regular':
            default:
                return 'px-2 py-1 rounded text-xs';
        }
    };
    var labelClass = classnames__WEBPACK_IMPORTED_MODULE_1___default()('font-medium mx-1 my-1', className, colourClass(colour), sizeClass(size));
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: labelClass,
        children: label
    }));
};


/***/ }),

/***/ 27221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Testimonial; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var _components_renderers_Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37324);
/* harmony import */ var _components_Authors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56794);
/* harmony import */ var _components_CardLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83228);
/* harmony import */ var _svg_icons_quote_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84915);






function Testimonial(param) {
    var externalUrl = param.externalUrl, linkPath = param.linkPath, title = param.title, coverImage = param.coverImage, customer = param.customer, company = param.company;
    var hasLogo = company && company.logo;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CardLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        externalUrl: externalUrl,
        linkPath: linkPath,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "transform rounded shadow-lg transition-all duration-100 ease-in-out hover:scale-105 hover:shadow-2xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative",
                    children: [
                        coverImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "z-20",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                src: coverImage.url,
                                title: title,
                                alt: title,
                                width: 960,
                                height: 540,
                                quality: 100,
                                objectFit: "cover",
                                className: "rounded"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            className: "absolute bottom-0 left-0 -mb-1 w-full fill-current text-cornflower",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 1440 320",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M0,192L120,208C240,224,480,256,720,234.7C960,213,1200,139,1320,101.3L1440,64L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "rounded-b bg-cornflower p-6",
                    children: customer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative z-20 rounded bg-white p-6 text-haiti shadow-lg",
                        children: [
                            customer.bio && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("blockquote", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pin-t pin-l absolute -mt-3 -ml-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg_icons_quote_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            className: "w-10 text-whisper"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative -mt-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_renderers_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            className: "text-sm italic",
                                            children: customer.bio
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "-ml-3 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "-ml-px flex-grow",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Authors__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            people: [
                                                customer
                                            ],
                                            showTitle: true
                                        })
                                    }),
                                    hasLogo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-16",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                            src: company.logo.url,
                                            width: company.logo.width,
                                            height: company.logo.height,
                                            title: company.name,
                                            alt: company.name
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    }));
};


/***/ }),

/***/ 64642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ForBusinesses; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./src/components/Layout/Vanilla.tsx + 22 modules
var Vanilla = __webpack_require__(1635);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
// EXTERNAL MODULE: ./src/components/LogoReel.tsx
var LogoReel = __webpack_require__(63016);
// EXTERNAL MODULE: ./src/components/USPCardRedesigned.tsx
var USPCardRedesigned = __webpack_require__(71985);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/MarkdownRenderer.tsx + 13 modules
var MarkdownRenderer = __webpack_require__(89338);
// EXTERNAL MODULE: ./src/components/Testimonial.js
var Testimonial = __webpack_require__(27221);
;// CONCATENATED MODULE: ./src/components/CaseStudyTabs.js






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CaseStudyTabs(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items;
    var hasItems = items || items.length > 0;
    var ref = (0,react.useState)(hasItems && items[0]), activeItem = ref[0], setActiveItem = ref[1];
    if (!hasItems) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "py-12 md:pt-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex overflow-hidden pb-6 md:-mb-6 md:justify-end md:pb-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full overflow-x-auto md:w-1/2 md:pl-6 lg:pl-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inline-flex space-x-6 border-b border-rock-blue",
                        children: items.map(function(item) {
                            var isActive = item === activeItem;
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: function() {
                                    return setActiveItem(item);
                                },
                                className: classnames_default()('focus:outline-none -mb-px flex-shrink-0 appearance-none border-b py-2 text-sm font-medium uppercase tracking-wider', {
                                    'border-royal-blue text-royal-blue': isActive,
                                    'border-rock-blue text-rock-blue': !isActive
                                }),
                                children: item.company.name
                            }, item.id));
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:flex md:items-center md:space-x-12 lg:space-x-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:w-1/2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial/* default */.Z, _objectSpread({}, activeItem, {
                            linkPath: "/case-studies/".concat(activeItem.slug)
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative md:w-1/2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownRenderer/* default */.Z, {
                                    content: activeItem === null || activeItem === void 0 ? void 0 : activeItem.excerpt
                                }),
                                (activeItem === null || activeItem === void 0 ? void 0 : activeItem.hasContent) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: activeItem === null || activeItem === void 0 ? void 0 : activeItem.linkPath,
                                    prefetch: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "group font-medium text-royal-blue",
                                        children: [
                                            "Read case study",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "ml-1 inline-block transform transition-transform duration-100 group-hover:translate-x-1",
                                                children: "→"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/pages/for-businesses.js








function for_businesses_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function for_businesses_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            for_businesses_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var enablingYouToBuildYourBest = [
    {
        image: {
            url: '/images/for-businesses/localized-content-royal-blue.svg',
            width: 259,
            height: 195
        },
        title: 'Localized Content',
        description: 'Whether you’re handling corporate presence in multiple regions or delivering locale-specific products, our out-of-the-box localization sets you up for success.',
        ctaTo: '/use-cases/content-localization'
    },
    {
        image: {
            url: '/images/for-businesses/structured-content-royal-blue.svg',
            width: 336,
            height: 231
        },
        title: 'Structured Content',
        description: 'Easily create, iterate on, and enrich your content. Further enhance it through third-party APIs, and unlock programmatic approaches to managing and delivering content.',
        ctaTo: '/use-cases/structured-content'
    },
    {
        image: {
            url: '/images/for-businesses/content-federation-royal-blue.svg',
            width: 255,
            height: 203
        },
        title: 'Content Federation',
        description: 'Break down your content silos. GraphCMS provides you with central control of your enterprise content from multiple sources through a single, unified content layer.',
        ctaTo: '/use-cases/content-federation'
    }, 
];
var headlessEnterpriseContent = [
    {
        icon: 'DatabaseLineIcon',
        title: 'End-to-end managed service',
        description: 'GraphCMS hosts your content in data centers of your choice, with your content cached across 190 edge CDN nodes globally. We provide custom support and performance SLAs with 24/7 infrastructure monitoring.'
    },
    {
        icon: 'ShieldUserLineIcon',
        title: 'Security & governance',
        description: 'Get granular content based permissions, audit logs, backups, and content retention to ensure you never lose business-critical information.'
    },
    {
        icon: 'TerminalLineIcon',
        title: 'Market leading APIs',
        description: 'GraphCMS gives you all your content from a single endpoint via the industry’s best APIs, giving you full access to our Management API, Content API, Assets API, and GraphQL mutations via our Mutations API.'
    },
    {
        icon: 'BubbleChartFillIcon',
        title: 'Agile content management',
        description: 'Use agile practices to minimize disruption to your customers, you need to carefully navigate your way through delivering new digital experiences with optimized workflows, reduced overheads, and minimal team-dependencies.'
    },
    {
        icon: 'TimerFlashLineIcon',
        title: 'Battle tested at every scale',
        description: 'With industry leading performance, security, and scalability, GraphCMS is trusted by companies ranging from the Fortune 500 to governments and public service companies.'
    },
    {
        icon: 'ShieldCheckLineIcon',
        title: 'Enterprise grade compliance',
        description: 'All our tools and services are compliant with, and certified against the strictest regulations. For further control, host your content on a dedicated infrastructure.'
    }, 
];
var __N_SSG = true;
function ForBusinesses(param1) {
    var page = param1.page, preview = param1.preview;
    var usps = page.usps, caseStudies = page.caseStudies;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Vanilla/* default */.Z, {
        seo: page,
        preview: preview,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "py-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-6xl px-4 md:px-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col space-y-12 md:flex-row md:items-center md:space-x-6 md:space-y-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full space-y-6 md:w-2/5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "font-semibold uppercase tracking-wider text-royal-blue",
                                            children: "For businesses"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "text-3xl font-bold leading-tight md:text-5xl",
                                            children: page.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "leading-relaxed text-zodiac md:text-lg",
                                            children: page.subTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            href: "https://graphcms.com/contact",
                                            colour: "royal",
                                            children: "Get enterprise demo →"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full md:w-3/5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative md:-mr-32",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: "/images/for-businesses/graphcms-for-enterprise-and-businesses.svg",
                                            alt: "for enterprise and small businesses",
                                            width: 747,
                                            height: 493
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid gap-x-6 pt-12 md:grid-cols-2 md:pb-6 lg:grid-cols-3 lg:pt-20",
                            children: usps.map(function(usp) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(USPCardRedesigned/* default */.Z, for_businesses_objectSpread({}, usp, {
                                    theme: "royal"
                                }), usp.id);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-whisper py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto max-w-6xl px-4 md:px-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoReel/* DefaultLogoReel */.x, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-white py-20 md:py-32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto max-w-6xl px-4 md:px-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-12 md:flex md:items-center md:space-y-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full md:w-1/2 md:pr-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative inline-flex items-center pb-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-sm font-medium uppercase tracking-widest text-royal-blue",
                                            children: "Deliver content at breakneck speeds"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "mb-4 text-xl font-bold leading-snug text-haiti md:text-2xl",
                                        children: "\"The time to market has drastically reduced from over 2 weeks to 3-4 days.\""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-6 text-light-haiti",
                                        children: "The BioCentury team rely on GraphCMS to federate their content from their CRM, CMS, and eCommerce systems, using GraphCMS as a programmatic Content Hub. The team delivers high-velocity content to millions of consumers globally, ensuring that mission-critical medical information doesn’t get lost at the speed of IT."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "/case-studies/biocentury-case-study",
                                        prefetch: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "group font-medium text-royal-blue",
                                            children: [
                                                "Learn how BioCentury does it",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "ml-1 inline-block transform transition-transform duration-100 group-hover:translate-x-1",
                                                    children: "→"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-full w-full md:flex md:w-1/2 md:items-center md:justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: "/images/for-businesses/biocentury.png",
                                    alt: "biocentury content federation",
                                    width: 1292,
                                    height: 904
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-haiti py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-6xl px-4 md:px-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-auto w-full space-y-6 pb-6 text-center md:pb-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-3xl font-bold leading-tight text-white md:text-5xl",
                                    children: "Unify All Your Investments"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-whisper",
                                    children: "Supercharge your team's content pipeline with endless extensibility."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto hidden max-w-4xl md:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: "/images/for-businesses/full-content-pipeline-royal-blue.svg",
                                alt: "full content pipeline",
                                className: "block",
                                width: 940,
                                height: 522
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "md:hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-3 py-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: "/images/for-businesses/content-sources-royal-blue.svg",
                                            className: "mb-12 block",
                                            alt: "content sources",
                                            width: 328,
                                            height: 290
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm font-medium uppercase tracking-widest text-royal-blue",
                                            children: "Sources"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-2xl font-bold leading-tight text-white",
                                            children: "Create Your Content"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-whisper",
                                            children: "Within minutes, define everything about your content API. Structures, localizations, relations, powerful permissions and more…"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-3 py-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: "/images/for-businesses/content-destinations-royal-blue.svg",
                                            className: "mb-12 block",
                                            alt: "omni-channel delivery",
                                            width: 328,
                                            height: 287
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm font-medium uppercase tracking-widest text-royal-blue",
                                            children: "Destination"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-2xl font-bold leading-tight text-white",
                                            children: "Put Your Content to Use"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-whisper",
                                            children: "Programmatically deliver to and consume content from several frontends and platforms like websites, portals, mobile, smart devices, and more."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-auto max-w-3xl pt-6 md:pt-12 md:text-center lg:pt-24",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mb-4 text-xl font-bold leading-snug text-white md:text-2xl",
                                    children: "See How GraphCMS Transforms Your Content Management"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-whisper",
                                    children: "GraphCMS plans are flexibly suited to accommodate your growth. Reach out to our sales team for a demo to discuss your projects and complex needs."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pt-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        href: "/contact",
                                        colour: "white",
                                        children: "Get enterprise demo →"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-white py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-6xl px-4 md:px-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-auto w-full space-y-6 pb-6 text-center md:pb-20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-3xl font-bold leading-tight text-haiti md:text-5xl",
                                    children: "Enabling Your Team to Build Their Best"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-auto max-w-3xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-zodiac",
                                        children: "GraphCMS unlocks operational efficiency for your team - by enabling agile workflows for your content creators and developers, to bring your ambitious projects to market faster."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid gap-x-6 gap-y-12 md:grid-cols-2 lg:grid-cols-3",
                            children: enablingYouToBuildYourBest.map(function(param) {
                                var image = param.image, title = param.title, description = param.description, cta = param.cta, ctaTo = param.ctaTo;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-3 md:space-y-6 lg:space-y-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: image.url,
                                                alt: title,
                                                width: image.width,
                                                height: image.height
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "space-y-3 py-3 md:space-y-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-xl font-bold text-haiti",
                                                    children: title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-light-haiti",
                                                    children: description
                                                }),
                                                ctaTo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: ctaTo,
                                                        prefetch: false,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: "group font-medium text-royal-blue",
                                                            children: [
                                                                cta || 'Learn more',
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "ml-1 inline-block transform transition-transform duration-100 group-hover:translate-x-1",
                                                                    children: "→"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, ctaTo);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center pt-10 md:pt-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full md:w-1/3 md:px-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    href: "/use-cases",
                                    appearance: "outline",
                                    colour: "royal",
                                    block: true,
                                    children: "See all solutions →"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-whisper py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-6xl space-y-12 px-4 md:space-y-24 md:px-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full space-y-6 text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-3xl font-bold leading-tight text-haiti md:text-5xl",
                                    children: "Here to Power Your Business Ambitions"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-auto max-w-3xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-zodiac",
                                        children: "Whether you’re a high-growth digital company with scaling needs or an enterprise business with modernizing global operations, GraphCMS forms the core of your stack, unifying your technologies and processes."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col-reverse md:flex-row md:items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full md:w-1/2 md:pr-20",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "mb-4 text-xl font-bold leading-snug text-haiti md:text-2xl",
                                            children: "Enable your stack to mature with your business"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-6 text-zodiac",
                                            children: "Stop hacky workarounds and compromising on your goals of delivering high-performance digital experiences because of inflexible web technologies."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/contact",
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "group font-medium text-royal-blue",
                                                children: [
                                                    "Talk to an expert to learn how",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "ml-1 inline-block transform transition-transform duration-100 group-hover:translate-x-1",
                                                        children: "→"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-full w-full pb-6 md:flex md:w-1/2 md:items-center md:justify-center md:pb-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: "/images/for-businesses/incoming-api-requests.svg",
                                        alt: "incoming api requests",
                                        width: 602,
                                        height: 398
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "md:flex md:items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-full w-full pb-6 md:flex md:w-1/2 md:items-center md:justify-center md:pb-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: "/images/for-businesses/graphcms-pipeline.svg",
                                        alt: "graphcms pipeline",
                                        width: 515,
                                        height: 348
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full md:w-1/2 md:pl-20",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "mb-4 text-xl font-bold leading-snug text-haiti md:text-2xl",
                                            children: "Modernize your business to embrace digital-first"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-6 text-zodiac",
                                            children: "Break down your silos by federating your content. GraphCMS can Integrate all your existing backend services and business processes to deliver content from a unified content layer"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/use-cases/content-federation",
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "group font-medium text-royal-blue",
                                                children: [
                                                    "Learn more about Content Federation",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "ml-1 inline-block transform transition-transform duration-100 group-hover:translate-x-1",
                                                        children: "→"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col-reverse md:flex-row md:items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full md:w-1/2 md:pr-20",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "mb-4 text-xl font-bold leading-snug text-haiti md:text-2xl",
                                            children: "Gain access to a global network of implementation & ecosystem partners"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-6 text-zodiac",
                                            children: "Need extra firepower to accelerate your development process? GraphCMS supports your needs to deliver on on enterprise expectations with our certified global partner network."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/partners",
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "group font-medium text-royal-blue",
                                                children: [
                                                    "Explore our partner network",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "ml-1 inline-block transform transition-transform duration-100 group-hover:translate-x-1",
                                                        children: "→"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-full w-full pb-6 md:flex md:w-1/2 md:items-center md:justify-center md:pb-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: "/images/for-businesses/partner-cards.svg",
                                        alt: "graphcms partners",
                                        width: 644,
                                        height: 444
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "bg-haiti py-20 md:py-32",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto max-w-6xl px-4 md:px-6 md:pt-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "md:flex md:items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full md:w-1/2 md:pr-20",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative inline-flex items-center pb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-sm font-medium uppercase tracking-widest text-royal-blue",
                                                children: "The monolith is dying, and taking you with it"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "mb-4 text-xl font-bold leading-snug text-white md:text-2xl",
                                            children: "\"Today’s customers demand a personalized experience across all digital touchpoints...\""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mb-6 text-whisper",
                                            children: "We’ve spoken to the leaders of the industry, from companies like AWS, G2, VWO, Optimove, Commerce Layer, and more, to understand where digital experiences are headed, and how a Headless CMS forms the foundation of DXPs moving forward."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/resources/dxp-report-2020",
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "group font-medium text-royal-blue",
                                                children: [
                                                    "Download the report",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "ml-1 inline-block transform transition-transform duration-100 group-hover:translate-x-1",
                                                        children: "→"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-full w-full pt-6 md:flex md:w-1/2 md:items-center md:justify-center md:pt-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: "/images/for-businesses/amit-bivas.png",
                                        alt: "amit bivas",
                                        width: 1292,
                                        height: 904
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto max-w-3xl px-6 pt-12 md:text-center lg:pt-32",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mb-4 text-xl font-bold leading-snug text-white md:text-2xl",
                                children: "See How GraphCMS Transforms Your Content Management"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-whisper",
                                children: "GraphCMS plans are flexibly suited to accommodate your growth. Reach out to our sales team for a demo to discuss your projects and complex needs."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    href: "/contact",
                                    colour: "white",
                                    children: "Get enterprise demo →"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-whisper py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-6xl px-4 md:px-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-auto w-full max-w-4xl space-y-6 text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-3xl font-bold leading-tight text-haiti md:text-5xl",
                                    children: "Headless Enterprise Content Management Trusted by Leaders"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-auto max-w-3xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-zodiac",
                                        children: "GraphCMS is relied upon across the world - from high-growth startups to the Fortune 500, from cloud-native SaaS companies to governments and public services."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid gap-x-6 pt-12 md:grid-cols-2 md:pb-6 lg:grid-cols-3 lg:pt-20",
                            children: headlessEnterpriseContent.map(function(usp, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(USPCardRedesigned/* default */.Z, for_businesses_objectSpread({}, usp, {
                                    theme: "royal"
                                }), index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center pt-10 md:pt-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full md:w-1/3 md:px-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    href: "/use-cases",
                                    colour: "royal",
                                    appearance: "outline",
                                    block: true,
                                    children: "Explore GraphCMS for enterprise →"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseStudyTabs, {
                            items: caseStudies
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center pt-10 md:pt-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full md:w-1/3 md:px-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    href: "/case-studies",
                                    colour: "royal",
                                    appearance: "outline",
                                    block: true,
                                    children: "Read all case studies →"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ }),

/***/ 82842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ canUseDOM; }
/* harmony export */ });
/* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97902);



function checkIsBrowser() {
  var _window = (0,_getWindow_js__WEBPACK_IMPORTED_MODULE_0__/* .getWindow */ .J)();

  return Boolean(typeof _window !== "undefined" && _window.document && _window.document.createElement);
}
/**
 * It's `true` if it is running in a browser environment or `false` if it is not (SSR).
 *
 * @example
 * import { canUseDOM } from "reakit-utils";
 *
 * const title = canUseDOM ? document.title : "";
 */


var canUseDOM = checkIsBrowser();




/***/ }),

/***/ 91481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ contains; }
/* harmony export */ });
/**
 * Similar to `Element.prototype.contains`, but a little bit faster when
 * `element` is the same as `child`.
 *
 * @example
 * import { contains } from "reakit-utils";
 *
 * contains(document.getElementById("parent"), document.getElementById("child"));
 */
function contains(parent, child) {
  return parent === child || parent.contains(child);
}




/***/ }),

/***/ 7589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getActiveElement; }
/* harmony export */ });
/* harmony import */ var _getDocument_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85708);


/**
 * Returns `element.ownerDocument.activeElement`.
 */

function getActiveElement(element) {
  var _getDocument = (0,_getDocument_js__WEBPACK_IMPORTED_MODULE_0__/* .getDocument */ .M)(element),
      activeElement = _getDocument.activeElement;

  if (!(activeElement !== null && activeElement !== void 0 && activeElement.nodeName)) {
    // In IE11, activeElement might be an empty object if we're interacting
    // with elements inside of an iframe.
    return null;
  }

  return activeElement;
}




/***/ }),

/***/ 85708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ getDocument; }
/* harmony export */ });
/**
 * Returns `element.ownerDocument || document`.
 */
function getDocument(element) {
  return element ? element.ownerDocument || element : document;
}




/***/ }),

/***/ 97902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getWindow; }
/* harmony export */ });
/* harmony import */ var _getDocument_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85708);


// Thanks to Fluent UI for doing the [research on IE11 memory leak](https://github.com/microsoft/fluentui/pull/9010#issuecomment-490768427)

var _window; // Note: Accessing "window" in IE11 is somewhat expensive, and calling "typeof window"
// hits a memory leak, whereas aliasing it and calling "typeof _window" does not.
// Caching the window value at the file scope lets us minimize the impact.


try {
  _window = window;
} catch (e) {
  /* no-op */
}
/**
 * Returns `element.ownerDocument.defaultView || window`.
 */


function getWindow(element) {
  if (!element) {
    return _window;
  }

  return (0,_getDocument_js__WEBPACK_IMPORTED_MODULE_0__/* .getDocument */ .M)(element).defaultView || _window;
}




/***/ }),

/***/ 47551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ hasFocusWithin; }
/* harmony export */ });
/* harmony import */ var _getActiveElement_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7589);
/* harmony import */ var _contains_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91481);




/**
 * Checks if `element` has focus within. Elements that are referenced by
 * `aria-activedescendant` are also considered.
 *
 * @example
 * import { hasFocusWithin } from "reakit-utils";
 *
 * hasFocusWithin(document.getElementById("id"));
 */

function hasFocusWithin(element) {
  var activeElement = (0,_getActiveElement_js__WEBPACK_IMPORTED_MODULE_0__/* .getActiveElement */ .v)(element);
  if (!activeElement) return false;
  if ((0,_contains_js__WEBPACK_IMPORTED_MODULE_1__/* .contains */ .r)(element, activeElement)) return true;
  var activeDescendant = activeElement.getAttribute("aria-activedescendant");
  if (!activeDescendant) return false;
  if (activeDescendant === element.id) return true;
  return !!element.querySelector("#" + activeDescendant);
}




/***/ }),

/***/ 37793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ isButton; }
/* harmony export */ });
var buttonInputTypes = ["button", "color", "file", "image", "reset", "submit"];
/**
 * Checks whether `element` is a native HTML button element.
 *
 * @example
 * import { isButton } from "reakit-utils";
 *
 * isButton(document.querySelector("button")); // true
 * isButton(document.querySelector("input[type='button']")); // true
 * isButton(document.querySelector("div")); // false
 * isButton(document.querySelector("input[type='text']")); // false
 * isButton(document.querySelector("div[role='button']")); // false
 *
 * @returns {boolean}
 */

function isButton(element) {
  if (element.tagName === "BUTTON") return true;

  if (element.tagName === "INPUT") {
    var input = element;
    return buttonInputTypes.indexOf(input.type) !== -1;
  }

  return false;
}




/***/ }),

/***/ 66016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ isSelfTarget; }
/* harmony export */ });
/**
 * Returns `true` if `event.target` and `event.currentTarget` are the same.
 */
function isSelfTarget(event) {
  return event.target === event.currentTarget;
}




/***/ }),

/***/ 4649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ matches; }
/* harmony export */ });
/**
 * Ponyfill for `Element.prototype.matches`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
 */
function matches(element, selectors) {
  if ("matches" in element) {
    return element.matches(selectors);
  }

  if ("msMatchesSelector" in element) {
    return element.msMatchesSelector(selectors);
  }

  return element.webkitMatchesSelector(selectors);
}




/***/ }),

/***/ 19354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YC": function() { return /* binding */ getFirstTabbableIn; },
/* harmony export */   "KE": function() { return /* binding */ getLastTabbableIn; },
/* harmony export */   "EB": function() { return /* binding */ isFocusable; },
/* harmony export */   "Wq": function() { return /* binding */ isTabbable; }
/* harmony export */ });
/* unused harmony exports getAllFocusableIn, getAllTabbableIn, getClosestFocusable, getFirstFocusableIn, getNextTabbableIn, getPreviousTabbableIn */
/* harmony import */ var _matches_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4649);





/** @module tabbable */
var selector = "input:not([type='hidden']):not([disabled]), select:not([disabled]), " + "textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], " + "iframe, object, embed, area[href], audio[controls], video[controls], " + "[contenteditable]:not([contenteditable='false'])";

function isVisible(element) {
  var htmlElement = element;
  return htmlElement.offsetWidth > 0 || htmlElement.offsetHeight > 0 || element.getClientRects().length > 0;
}

function hasNegativeTabIndex(element) {
  var tabIndex = parseInt(element.getAttribute("tabindex") || "0", 10);
  return tabIndex < 0;
}
/**
 * Checks whether `element` is focusable or not.
 *
 * @memberof tabbable
 *
 * @example
 * import { isFocusable } from "reakit-utils";
 *
 * isFocusable(document.querySelector("input")); // true
 * isFocusable(document.querySelector("input[tabindex='-1']")); // true
 * isFocusable(document.querySelector("input[hidden]")); // false
 * isFocusable(document.querySelector("input:disabled")); // false
 */


function isFocusable(element) {
  return (0,_matches_js__WEBPACK_IMPORTED_MODULE_0__/* .matches */ .w)(element, selector) && isVisible(element);
}
/**
 * Checks whether `element` is tabbable or not.
 *
 * @memberof tabbable
 *
 * @example
 * import { isTabbable } from "reakit-utils";
 *
 * isTabbable(document.querySelector("input")); // true
 * isTabbable(document.querySelector("input[tabindex='-1']")); // false
 * isTabbable(document.querySelector("input[hidden]")); // false
 * isTabbable(document.querySelector("input:disabled")); // false
 */

function isTabbable(element) {
  return isFocusable(element) && !hasNegativeTabIndex(element);
}
/**
 * Returns all the focusable elements in `container`.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 *
 * @returns {Element[]}
 */

function getAllFocusableIn(container) {
  var allFocusable = Array.from(container.querySelectorAll(selector));
  allFocusable.unshift(container);
  return allFocusable.filter(isFocusable);
}
/**
 * Returns the first focusable element in `container`.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 *
 * @returns {Element|null}
 */

function getFirstFocusableIn(container) {
  var _getAllFocusableIn = getAllFocusableIn(container),
      first = _getAllFocusableIn[0];

  return first || null;
}
/**
 * Returns all the tabbable elements in `container`, including the container
 * itself.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 * @param fallbackToFocusable If `true`, it'll return focusable elements if there are no tabbable ones.
 *
 * @returns {Element[]}
 */

function getAllTabbableIn(container, fallbackToFocusable) {
  var allFocusable = Array.from(container.querySelectorAll(selector));
  var allTabbable = allFocusable.filter(isTabbable);

  if (isTabbable(container)) {
    allTabbable.unshift(container);
  }

  if (!allTabbable.length && fallbackToFocusable) {
    return allFocusable;
  }

  return allTabbable;
}
/**
 * Returns the first tabbable element in `container`, including the container
 * itself if it's tabbable.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 * @param fallbackToFocusable If `true`, it'll return the first focusable element if there are no tabbable ones.
 *
 * @returns {Element|null}
 */

function getFirstTabbableIn(container, fallbackToFocusable) {
  var _getAllTabbableIn = getAllTabbableIn(container, fallbackToFocusable),
      first = _getAllTabbableIn[0];

  return first || null;
}
/**
 * Returns the last tabbable element in `container`, including the container
 * itself if it's tabbable.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 * @param fallbackToFocusable If `true`, it'll return the last focusable element if there are no tabbable ones.
 *
 * @returns {Element|null}
 */

function getLastTabbableIn(container, fallbackToFocusable) {
  var allTabbable = getAllTabbableIn(container, fallbackToFocusable);
  return allTabbable[allTabbable.length - 1] || null;
}
/**
 * Returns the next tabbable element in `container`.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 * @param fallbackToFocusable If `true`, it'll return the next focusable element if there are no tabbable ones.
 *
 * @returns {Element|null}
 */

function getNextTabbableIn(container, fallbackToFocusable) {
  var activeElement = getActiveElement(container);
  var allFocusable = getAllFocusableIn(container);
  var index = allFocusable.indexOf(activeElement);
  var slice = allFocusable.slice(index + 1);
  return slice.find(isTabbable) || allFocusable.find(isTabbable) || (fallbackToFocusable ? slice[0] : null);
}
/**
 * Returns the previous tabbable element in `container`.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 * @param fallbackToFocusable If `true`, it'll return the previous focusable element if there are no tabbable ones.
 *
 * @returns {Element|null}
 */

function getPreviousTabbableIn(container, fallbackToFocusable) {
  var activeElement = getActiveElement(container);
  var allFocusable = getAllFocusableIn(container).reverse();
  var index = allFocusable.indexOf(activeElement);
  var slice = allFocusable.slice(index + 1);
  return slice.find(isTabbable) || allFocusable.find(isTabbable) || (fallbackToFocusable ? slice[0] : null);
}
/**
 * Returns the closest focusable element.
 *
 * @memberof tabbable
 *
 * @param {Element} container
 *
 * @returns {Element|null}
 */

function getClosestFocusable(element) {
  while (element && !isFocusable(element)) {
    element = closest(element, selector);
  }

  return element;
}




/***/ }),

/***/ 49412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useForkRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


// https://github.com/mui-org/material-ui/blob/2bcc874cf07b81202968f769cb9c2398c7c11311/packages/material-ui/src/utils/useForkRef.js

function setRef(ref, value) {
  if (value === void 0) {
    value = null;
  }

  if (!ref) return;

  if (typeof ref === "function") {
    ref(value);
  } else {
    ref.current = value;
  }
}
/**
 * Merges up to two React Refs into a single memoized function React Ref so you
 * can pass it to an element.
 *
 * @example
 * import React from "react";
 * import { useForkRef } from "reakit-utils";
 *
 * const Component = React.forwardRef((props, ref) => {
 *   const internalRef = React.useRef();
 *   return <div {...props} ref={useForkRef(internalRef, ref)} />;
 * });
 */


function useForkRef(refA, refB) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (value) {
      setRef(refA, value);
      setRef(refB, value);
    };
  }, [refA, refB]);
}




/***/ }),

/***/ 66566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useIsomorphicEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _canUseDOM_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82842);





/**
 * `React.useLayoutEffect` that fallbacks to `React.useEffect` on server side
 * rendering.
 */

var useIsomorphicEffect = !_canUseDOM_js__WEBPACK_IMPORTED_MODULE_1__/* .canUseDOM */ .N ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;




/***/ }),

/***/ 19285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useLiveRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useIsomorphicEffect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66566);






/**
 * A `React.Ref` that keeps track of the passed `value`.
 */

function useLiveRef(value) {
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
  (0,_useIsomorphicEffect_js__WEBPACK_IMPORTED_MODULE_1__/* .useIsomorphicEffect */ .Y)(function () {
    ref.current = value;
  });
  return ref;
}




/***/ }),

/***/ 91791:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: useWarning, warning

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/reakit-warning/es/useWarning.js





function isRefObject(ref) {
  return isObject(ref) && "current" in ref;
}
/**
 * Logs `messages` to the console using `console.warn` based on a `condition`.
 * This should be used inside components.
 */


function useWarning(condition) {
  for (var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    messages[_key - 1] = arguments[_key];
  }

  if (false) {}
}



;// CONCATENATED MODULE: ./node_modules/reakit-warning/es/index.js







/***/ }),

/***/ 70507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; },
/* harmony export */   "U": function() { return /* binding */ useButton; }
/* harmony export */ });
/* harmony import */ var _rollupPluginBabelHelpers_1f0bf8c2_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17167);
/* harmony import */ var reakit_system_createComponent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11574);
/* harmony import */ var reakit_system_createHook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23543);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var reakit_utils_useForkRef__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49412);
/* harmony import */ var reakit_utils_isButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37793);
/* harmony import */ var reakit_warning__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91791);
/* harmony import */ var _Clickable_Clickable_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79639);



















// Automatically generated
var BUTTON_KEYS = [];

var useButton = (0,reakit_system_createHook__WEBPACK_IMPORTED_MODULE_2__/* .createHook */ .B)({
  name: "Button",
  compose: _Clickable_Clickable_js__WEBPACK_IMPORTED_MODULE_3__/* .useClickable */ .h,
  keys: BUTTON_KEYS,
  useProps: function useProps(_, _ref) {
    var htmlRef = _ref.ref,
        htmlProps = (0,_rollupPluginBabelHelpers_1f0bf8c2_js__WEBPACK_IMPORTED_MODULE_4__._)(_ref, ["ref"]);

    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

    var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined),
        role = _React$useState[0],
        setRole = _React$useState[1];

    var _React$useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("button"),
        type = _React$useState2[0],
        setType = _React$useState2[1];

    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
      var element = ref.current;

      if (!element) {
         false ? 0 : void 0;
        return;
      }

      if (!(0,reakit_utils_isButton__WEBPACK_IMPORTED_MODULE_5__/* .isButton */ .i)(element)) {
        if (element.tagName !== "A") {
          setRole("button");
        }

        setType(undefined);
      }
    }, []);
    return (0,_rollupPluginBabelHelpers_1f0bf8c2_js__WEBPACK_IMPORTED_MODULE_4__.a)({
      ref: (0,reakit_utils_useForkRef__WEBPACK_IMPORTED_MODULE_6__/* .useForkRef */ .c)(ref, htmlRef),
      role: role,
      type: type
    }, htmlProps);
  }
});
var Button = (0,reakit_system_createComponent__WEBPACK_IMPORTED_MODULE_7__/* .createComponent */ .L)({
  as: "button",
  memo: true,
  useHook: useButton
});




/***/ }),

/***/ 762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useRole; }
/* harmony export */ });
/* unused harmony export Role */
/* harmony import */ var _rollupPluginBabelHelpers_1f0bf8c2_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17167);
/* harmony import */ var reakit_system_createComponent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11574);
/* harmony import */ var reakit_system_createHook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23543);
/* harmony import */ var reakit_utils_shallowEqual__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60849);





// Automatically generated
var ROLE_KEYS = ["unstable_system"];

var useRole = (0,reakit_system_createHook__WEBPACK_IMPORTED_MODULE_0__/* .createHook */ .B)({
  name: "Role",
  keys: ROLE_KEYS,
  propsAreEqual: function propsAreEqual(prev, next) {
    var prevSystem = prev.unstable_system,
        prevProps = (0,_rollupPluginBabelHelpers_1f0bf8c2_js__WEBPACK_IMPORTED_MODULE_1__._)(prev, ["unstable_system"]);

    var nextSystem = next.unstable_system,
        nextProps = (0,_rollupPluginBabelHelpers_1f0bf8c2_js__WEBPACK_IMPORTED_MODULE_1__._)(next, ["unstable_system"]);

    if (prevSystem !== nextSystem && !(0,reakit_utils_shallowEqual__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .w)(prevSystem, nextSystem)) {
      return false;
    }

    return (0,reakit_utils_shallowEqual__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .w)(prevProps, nextProps);
  }
});
var Role = (0,reakit_system_createComponent__WEBPACK_IMPORTED_MODULE_3__/* .createComponent */ .L)({
  as: "div",
  useHook: useRole
});




/***/ }),

/***/ 68217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/** @license React vundefined
 * use-subscription.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(96086),g=__webpack_require__(67294);
exports.useSubscription=function(a){var c=a.getCurrentValue,d=a.subscribe,b=g.useState(function(){return{getCurrentValue:c,subscribe:d,value:c()}});a=b[0];var f=b[1];b=a.value;if(a.getCurrentValue!==c||a.subscribe!==d)b=c(),f({getCurrentValue:c,subscribe:d,value:b});g.useDebugValue(b);g.useEffect(function(){function b(){if(!a){var b=c();f(function(a){return a.getCurrentValue!==c||a.subscribe!==d||a.value===b?a:e({},a,{value:b})})}}var a=!1,h=d(b);b();return function(){a=!0;h()}},[c,d]);return b};


/***/ }),

/***/ 67161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(68217);
} else {}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3781,4814,8009,8575,5343,1635,9338,8953,1985,9774,2888,179], function() { return __webpack_exec__(49798); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);